import * as Yup from 'yup';
import { TFunction } from 'i18next';

export const createSchema = (t: TFunction) => Yup.object().shape({
  subdomain: Yup.string()
    .trim()
    .matches(
      /^([a-zA-Z0-9-]{1,63}\.)?[a-zA-Z0-9-]{1,63}$/,
      t('customDomain.schemaInvalidSubdomain')
    )
    .required(t('customDomain.schemaInvalidSubdomain')),

  domain: Yup.string()
    .trim()
    .matches(
      /^(?![0-9]+$)(?!-)[a-zA-Z0-9-]{1,63}(?<!-)(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
      t('customDomain.schemaInvalidDomain')
    )
    .required(t('customDomain.schemaInvalidDomain')),
});

export default createSchema;
